module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d3c86f1466ceed6f4ebd972e49e9c348.png";